import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledOnboarding = styled.div`
  form {
    margin-top: 36px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const HeadingText = styled.div`
  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 600;
    line-height: 1.05;
    letter-spacing: -0.025em;
    color: var(--text-color-50);
    text-wrap: balance;

    @media (min-width: 640px) {
      font-size: 40px;
    }
  }

  p {
    margin: 16px 0 0;
    max-width: 400px;
    font-size: 15px;
    line-height: 1.625;
    color: var(--text-color);
  }

  .gradient-text {
    background-image: var(--onboarding-brand-gradient);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const CenteredStep = styled.div`
  text-align: center;
`;

export const SetupSection = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin:  0 0 40px;
`;

export const PrepareList = styled.ul`
  margin: 32px 0 0;
  padding: 0;
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
`;

export const PrepareItem = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid var(--gray-350);
  border-radius: 12px;
  background: var(--white);
  font-size: 14px;
  box-shadow: var(--onboarding-shadow-soft);
  transition: all 0.2s ease;
  opacity: ${({ $done, $current }) => (!$done && !$current ? 0.4 : 1)};

  ${({ $current }) =>
    $current &&
    css`
      border-color: rgba(49, 49, 49, 0.2);
      box-shadow: var(--onboarding-shadow-elevated);
    `}

  svg.spinner {
    animation: spin 1s linear infinite;
    color: var(--blue);
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const Divider = styled.div`
  position: relative;
  padding: 4px 0;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    border-top: 1px solid var(--gray-350);
  }

  span {
    position: relative;
    display: flex;
    justify-content: center;
    background: var(--white);
    padding: 0 12px;
    margin: 0 auto;
    width: fit-content;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    color: var(--text-color);
  }
`;

export const LegalText = styled.p`
  padding-top: 12px;
  text-align: center;
  font-size: 12px;
  color: var(--text-color);

  a {
    text-underline-offset: 2px;
    color: var(--text-color-50);

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const PasswordField = styled.div`
  position: relative;

  button {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    padding: 0;
    color: var(--text-color);
    cursor: pointer;

    &:hover {
      color: var(--text-color-50);
    }
  }
`;

export const VerifyIconWrap = styled.div`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  margin: 0 auto 24px;
  border-radius: 16px;
  background-image: var(--onboarding-brand-gradient);
  box-shadow: var(--onboarding-shadow-elevated);

  svg {
    width: 24px;
    height: 24px;
    color: var(--white);
  }
`;

export const TrustGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  max-width: 440px;
  margin: 40px auto 0;

  @media (min-width: 640px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const TrustBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid var(--gray-350);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  font-weight: 500;
  color: var(--text-color);
  backdrop-filter: blur(8px);

  svg {
    width: 14px;
    height: 14px;
    color: var(--text-color-50);
  }
`;

export const ResendText = styled.p`
  margin-top: 20px;
  font-size: 14px;
  color: var(--text-color);

  button {
    border: none;
    background: transparent;
    padding: 0;
    font: inherit;
    font-weight: 500;
    color: var(--text-color-50);
    cursor: pointer;

    &:hover {
      color: var(--blue);
    }
  }
`;

export const AuthFooterLink = styled.p`
  margin-top: 24px;
  text-align: center;
  font-size: 14px;
  color: var(--text-color);

  @media (min-width: 640px) {
    display: none;
  }

  a {
    font-weight: 500;
    color: var(--text-color-50);

    &:hover {
      color: var(--blue);
    }
  }
`;

export const ForgotPasswordLink = styled(Link)`
  display: block;
  margin-top: -4px;
  text-align: right;
  font-size: 13px;
  font-weight: 500;
  color: var(--blue);
`;
